































































import { Component, Emit } from 'vue-property-decorator'
import { TriggerControlsMixin } from '@/components/TriggerSetup/logic/mixins/trigger-controls.mixin'
import { RawTriggerData } from '@/components/TriggerSetup/logic/types/types'
import { TriggerFactory } from '@/components/TriggerSetup/logic/factories/trigger-factory'

@Component
export default class TriggerControls extends TriggerControlsMixin {
  triggerFactory: TriggerFactory = new TriggerFactory()

  getRawTrigger(): RawTriggerData {
    return this.triggerFactory.triggerDataToRawTriggerData(this.triggerData)
  }

  @Emit()
  copy(): string {
    return this.$route.query.triggerKey.toString()
  }

  @Emit()
  reset(): RawTriggerData {
    return this.triggerFactory.getTriggerTemplate()
  }

  @Emit()
  remove(): RawTriggerData {
    return this.getRawTrigger()
  }

  @Emit()
  save(): RawTriggerData {
    return this.getRawTrigger()
  }

  @Emit()
  saveNoMove(): RawTriggerData {
    return this.getRawTrigger()
  }
}
